import { useMemo, useState } from 'react';
import { useBreakpoints } from '@cbhq/cds-web/hooks/useBreakpoints';
import { Box, VStack } from '@cbhq/cds-web/layout';

import { OnrampLogs } from ':cloud/pages/Onramp/OnrampLogs';
import { OnrampMetrics } from ':cloud/pages/Onramp/OnrampMetrics';
import { OnrampOverview } from ':cloud/pages/Onramp/OnrampOverview';
import { Layout } from ':cloud/widgets/layout';
import { FULL_PAGE_MAX_WIDTH, MAIN_CONTAINER_MIN_WIDTH } from ':cloud/widgets/product/constants';
import { KeyFeatureItem, KeyFeaturesSection } from ':cloud/widgets/product/KeyFeaturesSection';
import { UnroutedTopNavTabs } from ':cloud/widgets/sharedcomponents/UnroutedTopNavTabs';

const keyFeatures: KeyFeatureItem[] = [
  {
    iconName: 'addCard',
    title: 'More payment methods',
    description:
      "Accept payment methods already saved in your user's Coinbase account, including ACH, debit, and crypto balances. Users without a Coinbase account can buy with a debit card.",
  },
  {
    iconName: 'worldwide',
    title: 'Trusted global coverage',
    description:
      'Coinbase Pay supports 60+ fiat currencies with regulatory compliance and licensing, as well as 100+ cryptocurrencies with a rigorous asset listing process.',
  },
  {
    iconName: 'delegate',
    title: 'Built-in KYC and compliance',
    description:
      'No need to verify users and store their payment information. Coinbase can handle KYC, fraud claims and customer support cases on your behalf.',
  },
];

export function OnrampLanding() {
  const { isPhone } = useBreakpoints();
  const onrampTabs = useMemo(() => {
    return [
      { id: 'overview', label: 'Overview' },
      { id: 'metrics', label: 'Metrics' },
      { id: 'logs', label: 'Logs' },
    ];
  }, []);

  const [onrampTab, setOnrampTab] = useState(onrampTabs[0].id);

  return (
    <Layout enableMaxWidth={false}>
      <Layout.MainContainer minWidth={MAIN_CONTAINER_MIN_WIDTH} spacingHorizontal={0} fullWidth>
        <Box display="block" width="100%" minWidth="100%">
          <VStack>
            <UnroutedTopNavTabs value={onrampTab} tabs={onrampTabs} onChange={setOnrampTab} />
            <VStack>
              <VStack maxWidth={FULL_PAGE_MAX_WIDTH} flexGrow={1} width="100%">
                <VStack spacing={10} spacingTop={8} gap={5}>
                  {onrampTab === 'overview' && <OnrampOverview />}
                  {onrampTab === 'metrics' && <OnrampMetrics />}
                  {onrampTab === 'logs' && <OnrampLogs />}
                  <Box spacingBottom={isPhone ? 10 : 0}>
                    <KeyFeaturesSection features={keyFeatures} />
                  </Box>
                </VStack>
              </VStack>
            </VStack>
          </VStack>
        </Box>
      </Layout.MainContainer>
    </Layout>
  );
}
